/**
 * Returns the plain-text content of an HTML string (tags removed, entities
 * decoded). Subjects are plain text, but the rich-text editor can persist markup
 * (e.g. `<p>…</p>`); stripping it keeps a subject on a single line instead of
 * showing literal tags (plain-text placeholder) or a block-induced line break
 * (canvas preview rendered via dangerouslySetInnerHTML), and keeps the stored
 * value clean (save time).
 */
export const stripHtmlToText = (html: string): string => {
	if (!html) {
		return "";
	}

	const container = document.createElement("div");

	container.innerHTML = html;

	return (container.textContent || container.innerText || "").trim();
};
